<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive
      code="rech_ouinon"
      v-model="sas.sasEquivalence.desireAjouterRecherches"
      :live="{ endpoint: 'sas-equivalence', cle: '6148', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasRecherche"
      add-new-text="Ajouter une recherche"
      :live="{ endpoint: 'sas-recherche', sasId: sas.id }"
      :icon="$getIcon('recherche')"
      :valids="valids"
      ref="dataIterator"
      :opq-if="estOui(sas.sasEquivalence.desireAjouterRecherches)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.secteurDActivite }}</p>
        <p class="mb-0">{{ item.employeur }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="rech_secteur" v-model="item.secteurDActivite" :live="liveSasActiviteDeRecherche(8802, item)" />
        <MemoLive code="rech_description" v-model="item.descriptionDesActivitesDeRecherche" :live="liveSasActiviteDeRecherche(8803, item)" />
        <TextFieldLive code="rech_employeur" v-model="item.employeur" :live="liveSasActiviteDeRecherche(8804, item)" />
        <DatePickerLive code="rech_debut" v-model="item.dateDeDebut" :live="liveSasActiviteDeRecherche(8806, item)" />
        <DatePickerLive code="rech_fin" v-model="item.dateDeFin" :live="liveSasActiviteDeRecherche(8805, item)" />
        <FileInput code="rech_preuve" :file="item.preuve" :live="liveSasActiviteDeRecherche(8807, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasActiviteDeRecherche(cle, item) {
      return { endpoint: "sas-recherche", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>